import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { errorMessage } from '../helpers'

export const FETCH_ATTENDANCES = 'FETCH_ATTENDANCES'
export const FETCH_ATTENDANCES_SUCCESS = 'FETCH_ATTENDANCES_SUCCESS'
export const FETCH_ATTENDANCES_FAILURE = 'FETCH_ATTENDANCES_FAILURE'
export const SAVE_ATTENDANCES_SUCCESS = 'SAVE_ATTENDANCES_SUCCESS'
export const SAVE_ATTENDANCES_FAILURE = 'SAVE_ATTENDANCES_FAILURE'
export const ATTENDANCES_AJAX_CALL = 'ATTENDANCES_AJAX_CALL'
export const ATTENDANCES_CLEAR_AJAX_CALL = 'ATTENDANCES_CLEAR_AJAX_CALL'

export function loadAttendances(u) {
  return (dispatch) => {
    dispatch(fetchAttendances())
    axios({
      method: 'GET',
      url: URIS.attendances + '?u=' + u,
      headers: loadHeaders()
    })
      .then((res) => {
        dispatch(fetchAttendancesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(fetchAttendancesFailure(errorMessage(error)))
      })
  }
}

function fetchAttendances() {
  return {
    type: FETCH_ATTENDANCES
  }
}

function fetchAttendancesSuccess(payload) {
  return {
    type: FETCH_ATTENDANCES_SUCCESS,
    payload
  }
}

function fetchAttendancesFailure(payload) {
  return {
    type: FETCH_ATTENDANCES_FAILURE,
    payload
  }
}

export function saveAttendances(payload) {
  return (dispatch) => {
    dispatch(loadingAjaxCall())
    axios({
      method: 'POST',
      url: URIS.attendances,
      headers: loadHeaders(),
      data: payload
    })
      .then((res) => {
        dispatch(saveAttendancesSuccess(res.data))
      })
      .catch((error) => {
        dispatch(saveAttendancesFailure(errorMessage(error)))
      })
  }
}

function saveAttendancesSuccess(payload) {
  return {
    type: SAVE_ATTENDANCES_SUCCESS,
    payload
  }
}

export function saveAttendancesFailure(payload) {
  return {
    type: SAVE_ATTENDANCES_FAILURE,
    payload
  }
}

function loadingAjaxCall() {
  return {
    type: ATTENDANCES_AJAX_CALL
  }
}

export function clearAjaxCall(payload) {
  return {
    type: ATTENDANCES_CLEAR_AJAX_CALL
  }
}



// WEBPACK FOOTER //
// ./src/actions/Attendances.js